/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentTransactionId
 */
export interface PaymentTransactionId {
    /**
     * 
     * @type {string}
     * @memberof PaymentTransactionId
     */
    value?: string;
}

/**
 * Check if a given object implements the PaymentTransactionId interface.
 */
export function instanceOfPaymentTransactionId(value: object): boolean {
    return true;
}

export function PaymentTransactionIdFromJSON(json: any): PaymentTransactionId {
    return PaymentTransactionIdFromJSONTyped(json, false);
}

export function PaymentTransactionIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentTransactionId {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function PaymentTransactionIdToJSON(value?: PaymentTransactionId | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

